// 地图点位数据
export const startPoint = {
    name: '青浦区特殊教育指导中心',
    coords: [121.060417, 31.111692]
};

export const destinations = [
    { name: '白鹤镇', coords: [121.112133, 31.242894] },
    { name: '华新镇', coords: [121.213385, 31.226515] },
    { name: '徐泾镇', coords: [121.278826, 31.178794] },
    { name: '香花桥街道', coords: [121.128589, 31.177099] },
    { name: '重固镇', coords: [121.184522, 31.206799] },
    { name: '赵巷镇', coords: [121.202599, 31.155534] },
    { name: '盈浦街道', coords: [121.078161, 31.159543] },
    { name: '夏阳街道', coords: [121.119721, 31.127948] },
    { name: '金泽镇', coords: [120.973783, 31.051332] },
    { name: '练塘镇', coords: [121.058726, 31.005866] },
    { name: '朱家角镇', coords: [121.019272, 31.101045] }
];

// 生成移动线路数据
export const generateMoveLine = () => {
    return destinations.map((destination) => ({
        fromName: startPoint.name,
        toName: destination.name,
        coords: [
            startPoint.coords,
            destination.coords,
            startPoint.coords // 回到起点
        ]
    }));
}; 